const filterKey = [
  { title: "show all", key: "*" },
  { title: "Web3", key: "web3" },
  { title: "Trading", key: "trading" },
  { title: "AI Agent", key: "aiagent" },
  { title: "FullStack", key: "fullstack" },
  { title: "Mobile APP", key: "mobile" },
];

const projectData = [
  {
    type: ["web3","fullstack"],
    proName: "Launch Party",
    role: "Fullstack Web3 Developer",
    skills: ["Web3.Js", "Ethereum", "Smart Contracts", "Next.js"],
    imgUrl: "imgs/works/work22.png",
    summary:
      "A decentralized token launchpad that enables instant token creation and trading with automated liquidity and fair-launch.",
    siteUrl: "https://launch-monorepo-dev-frontend.vercel.app/",
  },
  {
    type: ["web3"],
    proName: "Flare Ninjas",
    role: "Frontend and Web3 Developer",
    skills: ["Next.js", "Web3.Js", "React"],
    imgUrl: "imgs/works/work17.jpg",
    summary:
      "Dual Staking Functionality, FlareDrop (WFLR) Delegation Pool, Purchase & Burn NINJA Token Buyback and Burn",
    siteUrl: "https://ninja.shogun-safari.xyz/",
  },
  {
    type: ["web3"],
    proName: "PUFF DOG",
    role: "FS Web3 Developer",
    skills: ["Web3.Js, Solana, Next.js"],
    imgUrl: "imgs/work/puff.png",
    summary:
      "A meme cryptocurrency built on the Solana blockchain, integrating NFTs and gaming.",
    siteUrl: "https://puffdognft.vercel.app/",
  },
  {
    type: ["web3","aiagent"],
    proName: "myai.zone",
    role: "AI Web3 Developer",
    skills: ["Web3.Js, Next.js, Python"],
    imgUrl: "imgs/work/myzone.png",
    summary:
      "Developing a budget-friendly AI image generator and NFT minting platform for MyAi token owners.",
    siteUrl: "https://myai.zone/image-ai",
  },
  {
    type: ["web3"],
    proName:"Little PEPE",
    role: "FS Web3 Developer",
    skills: ["TypeScript, Web3.Js, Ethereum, MongoDB"],
    imgUrl: "imgs/work/LILPEPE.png",
    summary:
      "Little Pepe is a Layer 2 blockchain engineered for speed, security, ultra-low fees—and powered by memes.",
    siteUrl: "https://littlepepe.com/",
  },
  {
    type: ["web3"],
    proName:"DengenTaxi",
    role: "Rust Developer",
    skills: ["Rust, Solana, Web3.Js, Node.js"],
    imgUrl: "imgs/work/Degen Tax.png",
    summary:
      "Degen Taxi proves the odds are as advertised and the rolls are predetermined and cannot react to how players bet.",
    siteUrl: "https://degentaxi.io/",
  },
  {
    type: ["fullstack"],
    proName:"wedance",
    role: "Fullstack Developer",
    skills: ["Nuxt.js, Express.js, TailwindCSS, PostgreSQL"],
    imgUrl: "imgs/work/wedance.png",
    summary:
      "A vibrant, international dance community for connecting dancers, discovering events, and welcoming family.",
    siteUrl: "https://wedance.vip/",
  },
  {
    type: ["trading"],
    proName:"Profitable Solana Triangle Arbitrage Bot",
    role: "Trading Bot Developer",
    skills: ["Solana, Web3.Js, TypeScript, Jito"],
    imgUrl: "imgs/work/arbitrage.png",
    summary:
      "Profitable Solana Arbitrage Trading bot running Raydium AMM, Raydium CMM, Pump.fun Meteora and so on.",
    siteUrl: "https://github.com/xtoshi999/Solana-Arbitrage-Trading-Bot",
  },
  {
    type: ["trading"],
    proName:"Solana Raydium Sniper Bot",
    role: "Trading Bot Developer",
    skills: ["Solana, Web3.Js, TypeScript, Hellius"],
    imgUrl: "imgs/work/SniperBotImage-hcfLh_8g.png",
    summary:
      "This trading bot is sniper bot with memecoin",
    siteUrl: "https://github.com/xtoshi999/Solana-Raydium-Sniper-Bot",
  },
  {
    type: ["aiagent"],
    proName:"AI Image Generaation",
    role: "AI Developer",
    skills: ["Python, TensorFlow, OpenAI API"],
    imgUrl: "imgs/work/AI image.png",
    summary:
      "Image generation tool that allows users to generate images based on their interests.",
    siteUrl: "https://ideogram.ai/",
  },

  {
    type: ["trading"],
    proName:"Solana Mev Bot",
    role: "Trading Bot Developer",
    skills: ["Solana, Web3.Js, TypeScript, Jito"],
    imgUrl: "imgs/work/MevBot.gif",
    summary:
      "A Solana MEV bot engineered for validator operators, combining ultra-fast infrastructure with adaptive algorithms to maximize arbitrage and transaction efficiency.",
    siteUrl: "https://github.com/xtoshi999/Solana-Mev-Bot",
  },



    {
    type: ["mobile"],
    proName:"Shopping App",
    role: "Mobile Developer",
    skills: ["Swift, React Native"],
    imgUrl: "imgs/work/shopapp.png",
    summary:
      "A shopping app fully made in SwiftUI for iOS 14.1.",
    siteUrl: "https://github.com/xtoshi999/Furniture-Shop-App-UI-SwiftUI",
  },
    {
    type: ["mobile"],
    proName:"Crowd",
    role: "Mobile Developer",
    skills: ["Swift, React Native"],
    imgUrl: "imgs/work/crowd.jpg",
    summary:
      "Web3 crowdfunding application using Vite.js, Tailwind CSS, & the Thirdweb SDK. ",
    siteUrl: "https://github.com/xtoshi999/web3_crowdfunding",
  },

  {
    type: ["aiagent"],
    proName:"Hugging Face",
    role: "AI Developer",
    skills: ["Python, TensorFlow, OpenAI API"],
    imgUrl: "imgs/work/Huggingface.png",
    summary:
      "Intelligent chatbot powered by machine learning with natural language processing capabilities.",
    siteUrl: "https://huggingface.co/",
  },
  
  {
    type: ["web3", "aiagent"],
    proName:"AI NFT Marketplace",
    role: "FS Web3 Developer",
    skills: ["React, AI, Python, Web3.Js, The Graph, IPFS"],
    imgUrl: "imgs/work/AI-NFT-Marketplace-DKaq35gb.png",
    summary:
      "Full NFT marketplace featuring lazy minting, royalties, and IPFS storage.",
    siteUrl: "http://nfprompt.io/",
  },
  {
    type: ["trading"],
    proName:"BTC ETH Pair Bot",
    role: "Trading Bot Developer",
    skills: ["TypeScript, Node.js, Ethers, Backend"],
    imgUrl: "imgs/work/DYDX_Bot-Bj59Gy_I.png",
    summary:
      "This trading bot is using DYDX account on https://mintscan.io",
    siteUrl: "https://github.com/xtoshi999/btc_eth_pair_bot",
  },
  {
    type: ["fullstack"],
    proName:"Casino",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "Ngnix"],
    imgUrl: "imgs/works/work19.jpg",
    summary:
      "Platform for games like Baccarat, Roulette, Andar Bahar, Sic Bo, Dragon tiger, Designed and Built all.",
    siteUrl: "https://kasagames.com/",
  },
  {
    type: ["web3", "fullstack"],
    proName:"FlareGod NFT",
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js"],
    imgUrl: "imgs/works/work1.jpg",
    summary:
      "web3 Mint Project : 15% of the mint cost is shared with web3 holders.",
    siteUrl: "https://flaregods.xyz/",
  },
  {
    type: ["fullstack"],
    proName:"Sports Betting",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "Ngnix"],
    imgUrl: "imgs/works/work20.jpg",
    summary: "Sports Betting Site",
    siteUrl: "https://blockchainbets.club/",
  },
  {
    type: ["trading"],
    proName:"Wallet Tracker",
    role: "Trading Bot Developer",
    skills: ["TypeScript, Next.js, tRPC, X API v2"],
    imgUrl: "imgs/work/whaletracker.gif",
    summary:
      "Implemented T3 stack frontend with wallet tracking and Twitter notifications integration.",
    siteUrl: "https://wallet-tracking-app.vercel.app",
  },
  {
    type: ["fullstack", "web3"],
    proName:"Coin-flip Game",
    role: "Frontend and Web3 Developer",
    skills: ["React.Js", "Node.Js", "Solana", "Rust"],
    imgUrl: "imgs/works/work10.jpg",
    summary:
      "This is coin-flip game on solana network. Payment is Sol and users can put their amount in this game. ",
    siteUrl: "https://coinflip.deezkits.com/",
  },
   {
    type: ["aiagent"],
    proName:"AI Image Generation",
    role: "AI Developer",
    skills: ["Python, TensorFlow, OpenAI API"],
    imgUrl: "imgs/work/AI Dezgo.png",
    summary:
      "Image generation tool that allows users to generate images based on their preferences",
    siteUrl: "https://dezgo.com/",
  },
  {
    type: ["web3"],
    proName:"Web3 Minting",
    role: "Frontend and Web3 Developer",
    skills: ["Next.Js", "Node.Js", "Three.Js", "Web3.Js"],
    imgUrl: "imgs/works/work12.jpg",
    summary: "Cobalt web3 Minting",
    siteUrl: "https://cobalt.shop/",
  },
  {
    type: ["trading"],
    proName:"TheWise.Trade",
    role: "Trading Automation Developer",
    skills: ["TypeScript, Vue.js, DLMM"],
    imgUrl: "imgs/work/wisetrade.gif",
    summary:
      "DLMM active pool, Meteora open positions, and performance tracking integration.",
    siteUrl: "https://thewise.trade",
  },
  {
    type: "web3",
    proName:"Crypto Legion Game",
    role: "Solidity and Rust Developer",
    skills: ["React.Js", "Web3.Js", "Solidity", "Ethereum"],
    imgUrl: "imgs/works/work11.jpg",
    summary: "Crypto Legions Game (P2E)",
    siteUrl: "https://cryptolegions.app/",
  },
  {
    type: ["web3", "fullstack"],
    proName:"Web3 Minting",
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work7.jpg",
    summary: "BeastiyBit web3 Minting",
    siteUrl: "https://beastybits.com/",
  },
  {
    type: ["web3"],
    proName:"Wbe3 Minting",
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work8.jpg",
    summary: "CuteInsane web3 Minting | Staking",
    siteUrl: "https://cutetoinsane.online/",
  },
  {
    type: ["web3"],
    proName:"Solarmy",
    role: "Solana Developer",
    skills: ["Next.Js", "Node.Js", "AWS", "Solana"],
    imgUrl: "imgs/works/work5.png",
    summary: "Solarmy | web3 Game | web3 Staking | Fusion",
    siteUrl: "https://game.solarmy.io/",
  },
  {
    type: ["web3"],
    proName:"Web3 Marketplace",
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work3.png",
    summary: "web3 Marketplace (Songbird Network)",
    siteUrl: "https://market.doodcats.net/",
  },
  {
    type: ["mobile"],
    proName:"Nexplore App",
    role: "Mobile Developer",
    skills: ["React Native, Expo SDK, Tailwind CSS,TypeScript"],
    imgUrl: "imgs/work/nexplore.jpg",
    summary:
      "Users can search and find local hotel, restaurants, and attractions within a particular area",
    siteUrl: "https://github.com/xtoshi999/Nexplore_app",
  },
    {
    type: "fullstack",
    proName:"Mercari",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "GraphQL"],
    imgUrl: "imgs/works/work14.jpg",
    summary: "MercariLogo Marketplace (Designed the site and the database.)",
    siteUrl: "https://www.mercari.com/",
  },
  {
    type: ["mobile"],
    proName:"Virtual Companion Platform",
    role: "Mobile Developer",
    skills: ["Python, JavaScript, TypeScript, Swift,Kottlin"],
    imgUrl: "imgs/work/Virtual Companion Platform.png",
    summary:
      "AI-powered platform, featuring conversational AI, real-time voice synthesis, and AI-generated imagery.",
    siteUrl: "https://github.com/xtoshi999/virtual-companion-platform",
  },
  {
    type: ["web3"],
    proName:"Doodle Bunny",
    role: "Frontend and Web3 Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work2.jpg",
    summary: "web3 Minting | Staking",
    siteUrl: "https://doodlebunnyflr.live/",
  },
  {
    type: ["web3"],
    proName:"TSP Hunt",
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work18.jpg",
    summary: "web3 Staking in Songbird Network",
    siteUrl: "https://tsphunt.xyz/",
  },
  {
    type: ["web3"],
    proName:"DoodCat",
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work4.jpg",
    summary:
      "web3 Staking (Songbird Network). Holders may stake DoodCats v3 web3s and DedDoods web3s to earn sDOOD Token.",
    siteUrl: "https://doodcats.net/",
  },
    {
    type: ["trading"],
    proName:"Discord Bingo Bot",
    role: "Discord Bot Developer",
    skills: ["Discord.js, Javascript"],
    imgUrl: "imgs/work/discord-bingo-bot.jpeg",
    summary:
      "A discord.js bot environment setup for you to use in all your Discord Bot projects based on Slash Commands!",
    siteUrl: "https://github.com/xtoshi999/Discord-Bingo-Bot",
  },
  {
    type: ["web3"],
    proName:"Breeding dAPp",
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work21.png",
    summary: "web3 Breeding Dapp",
    siteUrl: "https://portal.animalove.art/",
  },
  {
    type: ["mobile"],
    proName:"Health Monitoring App",
    role: "Mobile Developer",
    skills: ["JavaScript, React Native, Node.js,MongoDB"],
    imgUrl: "imgs/work/Health Monitoring.png",
    summary:
      "A comprehensive health monitoring app that enables users to track vital signs, medication schedules, and wellness activities.",
    siteUrl: "https://github.com/xtoshi999/health-monitoring",
  },
  {
    type: ["web3"],
    proName:"Staking & Marketplace contract",
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work16.jpg",
    summary:
      "CashCow Protocol (Designed the site with Figma, Built the staking and marketplace contract)",
    siteUrl: "https://cashcowprotocol.com/",
  },
  {
    type: "fullstack",
    proName:"Di Bruno E-Commerce",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "GraphQL", "AWS"],
    imgUrl: "imgs/works/work13.jpg",
    summary: "Di Bruno Bros E-Commerce",
    siteUrl: "https://dibruno.com/",
  },
  {
    type: "fullstack",
    proName:"Littlespoon E-Commerce",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js"],
    imgUrl: "imgs/works/work15.jpg",
    summary: "Littlespoon E-Commerce",
    siteUrl: "https://www.littlespoon.com/",
  },
];

export { filterKey, projectData };
